var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:_vm.styles.root},[_c('div',{class:[_vm.styles.logo, _vm.styles['skeleton-logo']]}),_c('div',{class:_vm.styles['skeleton-text']},[_c('div',{class:_vm.styles.skeleton,style:({ width: _vm.width })})])])
}
var staticRenderFns = []

export { render, staticRenderFns }